import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--export-spinner"
export default class extends Controller {
  static targets = ['exportContainer']
  static values = {
    url: String,
    exportStatus: String
  }

  async connect() {
    if (this.exportStatusValue === 'false') {
      setInterval(async () => {
        const response = await fetch(this.urlValue, {
          method: 'GET'
        });
        let response_data = await response.json();
        if (response_data['status'] === 'ok') {
          this.exportContainerTarget.outerHTML  = response_data['html']
        }
      }, 5000)

    }
  }
}
